// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ENV } from './env.enum';

export const environment = {
  environment: ENV.DEV,
  production: false,
  persistUserSession: true,
  ClientUrl: 'https://dev-jobnet.trimor.com/',
  apiEndPoint: 'https://jobnet-api-dev.azurewebsites.net/',
  clientId: 'f4413a06-abf2-4010-ba58-88b80a54a7a2',
  tenantId: 'ee5d6ef2-372b-4831-b88d-b8ca7635926a',
  graphAPI: {
    resourceUri: 'https://graph.microsoft.com/v1.0/me',
    resourceScopes: ['user.read'],
  },
  JobScheduleAPI: {
    resourceScopes: [
      'api://f4413a06-abf2-4010-ba58-88b80a54a7a2/.default offline_access openid',
    ],
  },
  msAzureConnection: {
    appService: 'jobnet-client-Dev',
    ftpsEndPoint:
      'ftps://waws-prod-bn1-079.ftp.azurewebsites.windows.net/site/wwwroot',
    username: 'jobnet-client-Dev\$jobnet-client-Dev',
    password: 'BCLaBCfC29X1qbLqauCaowHTvPNclgTRH86z3hMDtFyd6opMFiCpXpzzYHva',
  },
  jobScheduleRedirect: 'https://dev.trimor.com/foreman/admin/scheduler'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
